// extracted by mini-css-extract-plugin
module.exports = {"cellWrapper":"suppressionList__cellWrapper___i0L0a","ReactTableCustom":"suppressionList__ReactTableCustom___16JGQ"};